import { StorePoint, PointType } from '../types';

export const getPointTypes = (points: StorePoint[]): PointType[] => {
  return [...new Set(points.map((point) => point.city || ''))];
};
